import { Card, CardContent, CardDescription, CardHeader } from "@components/ui/card";
import { Skeleton } from "@components/ui/skeleton";

export const TemplateCardSkeleton = () => {
  return (
    <Card className="px-0">
      <CardHeader className="flex items-start justify-between px-6">
        <div className="flex-1 gap-2">
          <div className="flex items-center gap-3">
            <Skeleton className="h-7 w-48" />
            <Skeleton className="h-6 w-20" />
          </div>
          <CardDescription className="flex items-center gap-4 pt-3 text-xs">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-28" />
          </CardDescription>
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-36" />
        </div>
      </CardHeader>

      <CardContent className="border-t px-6 pt-6">
        <div className="space-y-3">
          <Skeleton className="h-10 w-full" />
          <div className="space-y-2 pl-4">
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-4 w-2/3" />
            <Skeleton className="h-4 w-5/6" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
